import { render, staticRenderFns } from "./BaseIconPreference.vue?vue&type=template&id=666356e0"
import script from "./BaseIconPreference.vue?vue&type=script&lang=js"
export * from "./BaseIconPreference.vue?vue&type=script&lang=js"
import style0 from "./BaseIconPreference.vue?vue&type=style&index=0&id=666356e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports